import * as React from "react";
import { useNavigate } from "react-router-dom";
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import Slider from "react-slick";
import { Hearts } from 'react-loading-icons'
import { motion } from "framer-motion";
import { CardContext } from './CardProvider';


export const Choose = () => {
    window.scrollTo(0, 0);

    const navigate = useNavigate();
    const {cardInfo, setCardInfo} = React.useContext(CardContext)
  
    const [items, setItems] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [isError, setIsError] = React.useState(false);
    const [ittengo, setIttengo] = React.useState(false);
    // const [message, setMessage] = React.useState('');
    // const [giftId, setGiftId]   = React.useState();
  
    const slideChanged = (index) => {
      setIttengo(items[index]);
    }
  
    const settings = {
      dots: true,
      infinite: true,
      arrows: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      afterChange: slideChanged
    };
  
    const fetchData = () => {
      fetch("https://" + process.env.REACT_APP_API_HOST + "/api/v1/gift/ittengo/?campaign_id=1", {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      })
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoading(false);
          setItems(result.results);
          setIttengo(result.results[0]);
        })
      .catch(
        (error) => {
          setIsLoading(false);
          setIsError(true);
          console.log(error);
        }
      )
    };
    React.useEffect(() => {
      fetchData();
    }, [])
  
    const handleSubmit = () => {
      navigate('/mothersday2022/message',
        { state: { ittengo: ittengo }}
      );
    }
  
    if (isLoading) {
      return <main className="d-flex vh-100"><Hearts className="m-auto" stroke="#FBC1B8" fill="#FBC1B8" height="8em" /></main>
    }
    return (
      <>
        <motion.div
          animate={{
            x: 0,
            opacity: 1
          }}
          initial={{
            x: 100,
            opacity: 0
          }}
          exit={{
            x: -100,
            opacity: 0
          }}
          transition={{
            duration: 0.2
          }}
        >
          <main>
            <h2>1. カードの選択</h2>
  
            <Slider {...settings} className="mt-4">
              {items && items.map((item, index) => <div key={index}><Image src={item.image} alt={item.honkaku.title} fluid /></div>)}
            </Slider>
  
            <div className="mt-5">
              <Button variant="warning" className="btn-lg" onClick={handleSubmit}>このカードにする</Button>
            </div>
  
          </main>
        </motion.div>
      </>
    );
  }